module.exports = "<!-- <alg-accordion-header\n  [status]=\"status\"\n  [title]=\"title\"\n  [icon]=\"icon\"\n  [open]=\"isOpen\"\n  [ngClass]=\"{'pointer': status != 'disable', 'noPointer' : status == 'disabled'}\"\n  (click)=\"toggle()\">\n</alg-accordion-header> -->\n<div class=\"accordion-content\">\n  <ng-content></ng-content>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/molecules/alg-accordion/alg-accordion.component.html
// module id = ./src/app/components/molecules/alg-accordion/alg-accordion.component.html
// module chunks = main